import ProductCreateFormComponent from "../components/productCreate/ProductCreateForm.Component";

const ProductCreatePageComponent = () => {
  return <ProductCreateFormComponent />;
};

export default ProductCreatePageComponent;
